module.exports = __webpack_public_path__ + "4a7a2c4e753bd2de770c7d1b290a1eff.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/face/index/images/jiaoyubao1.png
// module id = 246
// module chunks = 3